import React, { useEffect } from 'react';
import Icon from '../AppIcon';

const ActionToast = ({ notice, onClose }) => {
    useEffect(() => {
        if (!notice) return undefined;
        const timer = setTimeout(onClose, notice.type === 'error' ? 7000 : 4000);
        return () => clearTimeout(timer);
    }, [notice, onClose]);
    if (!notice) return null;
    const success = notice.type === 'success';
    const warning = notice.type === 'warning';
    const tone = success ? 'border-green-200 bg-green-50 text-green-900' : warning ? 'border-amber-200 bg-amber-50 text-amber-900' : 'border-red-200 bg-red-50 text-red-900';
    return <div className={`fixed right-5 top-5 z-[200] flex max-w-md items-start gap-3 rounded-lg border p-4 shadow-xl ${tone}`} role="status">
        <Icon name={success ? 'CheckCircle2' : warning ? 'AlertTriangle' : 'AlertCircle'} className="mt-0.5 h-5 w-5 shrink-0" />
        <div className="flex-1"><div className="font-semibold">{success ? 'Success' : warning ? 'Completed with items to review' : 'Action failed'}</div><div className="mt-0.5 text-sm">{notice.message}</div></div>
        <button type="button" onClick={onClose} aria-label="Dismiss notification"><Icon name="X" className="h-4 w-4" /></button>
    </div>;
};

export default ActionToast;
